import React from 'react'
import SbEditable from 'storyblok-react'
import RichText from 'src/utils/RichText'
import Heading from 'src/components/Heading'
import Button from 'src/components/Button'
import GetAny from 'src/utils/GetAny'
import ArchiveItem from 'src/components/Archive/ArchiveItem'
import Wave from 'src/utils/Wave'
import LogoSwirl from 'src/images/logo_swirl.svg'

const FeaturedPostTypes = ({ blok }) => {
    return (
        <SbEditable content={blok} key={blok._uid}>
            <div>
                {!blok.curve_at_bottom && <Wave size="small" className={`fill-lightgrey`} flip/>}
                <div className="bg-lightgrey">
                    <div className="relative max-w-7xl mx-auto px-6 lg:py-24 py-12 2xl:max-w-screen-2xl">
                        <div className="flex lg:flex-row flex-col lg:justify-between lg:items-end gap-y-4">
                            <div>
                                <Heading size="h3" className="">{blok.title}</Heading>
                                <div className="prose lg:text-base text-sm max-w-3xl">
                                    <RichText>{blok.description}</RichText>
                                </div>
                            </div>
                            {blok.button_text &&
                                <div>
                                    <Button to={blok.button_target.cached_url} className="">{blok.button_text}</Button>
                                </div>
                            }
                        </div>
                        <div className="lg:pt-14 pt-10 grid gap-12 lg:grid-cols-2 lg:gap-x-8 gap-y-8">
                            {blok.stat && GetAny(blok.stat).map((item) => (
                                <div key={item.uuid} className="relative bg-blue rounded-md  w-full xl:px-20 md:px-8 px-6 xl:py-36 lg:py-24 md:py-36 py-20 flex flex-col items-center justify-center">
                                    <Heading size="h2" className="text-cyan text-center lg:!text-7xl md:!text-6xl !text-5xl !font-bold">{item.name}</Heading>
                                    <Heading size="h5" className="text-white text-center">{item.content.description}</Heading>
                                    <LogoSwirl className="fill-cyan absolute md:w-9 w-7 md:bottom-[10%] bottom-[8%] left-1/2 -translate-x-1/2"/>
                                </div>
                            ))}
                            <div className="relative">
                                <div className="grid gap-8 md:grid-cols-2">
                                    {GetAny(blok.posts).map((item) => (
                                        <ArchiveItem {...item} key={item.uuid}/>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {blok.curve_at_bottom && <Wave size="small" className={`fill-lightgrey`}/>}
            </div>
        </SbEditable>
    )
}

export default FeaturedPostTypes